fx.ns("desktop.common.toolbar", class ToolBarBrightnessSelector  extends shared.stage.ToolBarButton{
    
    constructor(command, component, container, model)
    {
        super(command, component, container);
        this.data = model;
        this._scrollerDisplayed  = false;

        this.listenUpdates(component.data, true)
    }

  
    create()
    {
        let brightness = this.component.data.luminosity;
        let contrast = this.component.data.contrast;
        let saturation = this.component.data.saturation;

        this.scroller = new fx.components.Box("BrightnessSelectorContainer");
        this.scroller.visibleAtStart = false;

        this.textlabelBrightness = new fx.components.Text({className : "textLabel", text : fx.text("Luminosité")});
        this.rangeBrightness = new fx.components.InputRange({value : brightness, min : -100, max : 100});
        
        this.textlabelContrast = new fx.components.Text({className : "textLabel", text : fx.text("Contraste")});
        this.rangeContrast = new fx.components.InputRange({value : contrast, min : -100, max : 100});
        
        this.textlabelSaturation = new fx.components.Text({className : "textLabel", text : fx.text("Saturation")});
        this.rangeSaturation = new fx.components.InputRange({value : saturation, min : -100, max : 100});
        
        this.resetButton = new fx.components.Button({className : "textLabel", label : fx.text("Annuler")});

        this.scroller.addChild( this.rangeBrightness, {width : 100, height :15, top : 12.5, left : 5});
        this.scroller.addChild( this.textlabelBrightness, {width : "auto", height :20, top : 34, left : 25});
        
        this.scroller.addChild( this.rangeContrast, {width : 100, height :15, top : 12.5, left : 107});
        this.scroller.addChild( this.textlabelContrast, {width : "auto", height :20, top : 34, left : 130});
        
        this.scroller.addChild( this.rangeSaturation, {width : 100, height :15, top : 12.5, left : 210});
        this.scroller.addChild( this.textlabelSaturation, {width : "auto", height :20, top : 34, left : 230});
        
        this.scroller.addChild( this.resetButton, {width : 65, height :30, left : 295, top : 0});

        this.container.addChild( this.scroller, {width : 400, height :50, bottom : -50,/*top:this.container.realHeight,*/ left : "center"} );
    }

    onReady()
    {
        super.onReady();
        
        this.on("click",this._click, window);
        this.on("click", this._reset, this.resetButton);
        this.on("changed", this._updateRangeBrightness, this.rangeBrightness);
        this.on("changed", this._updateRangeContrast, this.rangeContrast);
        this.on("changed", this._updateRangeSaturation, this.rangeSaturation);
    }

    _reset(){
        this.rangeSaturation.value = 0;
        this.rangeBrightness.value = 0;
        this.rangeContrast.value = 0;
        this._updateRangeBrightness();
        this._updateRangeSaturation();
        this._updateRangeContrast();
    }

    _updateRangeBrightness()
    {
        //this.rangeBrightnessValue.text = this.rangeBrightness.value+"%"; 
        this.component.data.luminosity = this.rangeBrightness.value;
        this._action();
    }

    _updateRangeSaturation()
    {
        //this.rangeSaturationValue.text = this.rangeSaturation.value+"%"; 
        this.component.data.saturation = this.rangeSaturation.value;
        this._action();
    }

    _updateRangeContrast()
    {
        //this.rangeContrastValue.text = this.rangeContrast.value+"%"; 
        this.component.data.contrast = this.rangeContrast.value;
        this._action();
    }

    _action()
    {
        this.action( {});
    }

    click()
    {
        // we disabled default action on click
    }

    _click(event)
    {
        if (!this.enabled)
            return;

        let toolBar = fx.dom.parent(event.target, ".ToolBar");
        if (!toolBar)
            return;

        let target1 = fx.dom.parent(event.target, ".ToolBarBrightnessSelector");
        let target2 = fx.dom.parent(event.target, ".BrightnessSelectorContainer");
        

        if ( (target1 && target1.id == this.id) )
            this.updateScoller(!this.scroller.visible);
        else
        if ( ( !target2 || target2.id != this.scroller.id) && this._scrollerDisplayed )
            this.updateScoller(false);
            
    }

    updateScoller(show)
    {
        if (show)
        {
            this.scroller.show();
            this.addClass("pushed");
        }
        else
        {
            this.scroller.hide();
            this.removeClass("pushed");
        }

        this._scrollerDisplayed = show;
    }


    destroy()
    {
        super.destroy();


        if (this.container && this.scroller)
            this.container.removeChild( this.scroller , true);

    }


    hide()
    {
        super.hide();
        this.css({display:"none"});
    }

    show()
    {
        super.show();
        this.css({display:"inline-block"});
    }

    onDataUpdated(action)
    {
        // fix tracks https://my.trackjs.com/details/2b23bbaafd734c9daa97943c4c3ea655
        if (!this.component || !this.component.data)
            return;
            
        if (action.impacts("saturation"))
        {
            this.rangeSaturation.value = this.component.data.saturation;
            this._updateRangeSaturation();
        }

        if (action.impacts("luminosity"))
        {
            this.rangeBrightness.value = this.component.data.luminosity;
            this._updateRangeBrightness();
        }

        if (action.impacts("contrast"))
        {
            this.rangeContrast.value = this.component.data.contrast;
            this._updateRangeContrast();
        }
    }
  
});
